<template>
  <x-page
    title=""
    :loading="loading"
    transparent-header
    :white-back="true"
    custom-background="#18B88C "
  >
    <template v-if="!loading">
      <img :class="_.headImg" src="./../../images/2023/背景.png" alt="" />
      <div :class="_.container">
        <div
          v-for="(item, index) in stateContentlist"
          :key="index"
          :class="_.station"
        >
          <div :class="_.headtitle">
            {{ item[0] ? item[0].title : '' }}
          </div>
          <template v-for="(cont, idx) in item">
            <img
              v-if="idx > 0"
              :key="idx"
              :class="_.list"
              :src="cont.icon"
              alt=""
              @click="toDetail(cont.targetUrl)"
          /></template>
        </div>
      </div>
    </template>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { Track } from '@/utils/Track'

  import { dcb } from '@dcb/jssdk'

  import { apiPageConfigGetStateContentByApp } from '@/api'

  export default Vue.extend({
    mixins: [
      Track.provideMark(() => ({
        page: '首页',
      })),
    ],

    data() {
      return {
        loading: false,
        stateContentlist: [],
      }
    },

    async mounted() {
      this.loading = true
      await this.getStateContentByApp('8aaa87b582b545060182f6cfb7c101fa')
      await this.getStateContentByApp('8aaa87b582b545060182f6d185bd01fd')
      await this.getStateContentByApp('8aaa87b582b545060182f6d2b3430200')
      await this.getStateContentByApp('8aaa87b582b545060182f6d3d15e0203')
      this.loading = false
    },

    methods: {
      async getStateContentByApp(id) {
        const { list } = await apiPageConfigGetStateContentByApp({
          stateId: id,
          pageIndex: 1,
          pageSize: 50,
        })
        this.stateContentlist.push(list)
        console.log('1231313--->', list, this.stateContentlist)
      },
      toDetail(url) {
        dcb.navigateTo({
          url: url,
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .headImg {
    width: 100%;
    height: 189px;
  }
  .container {
    padding-left: 12px;
    padding-right: 12px;
    box-sizing: border-box;
    .station {
      position: relative;
      top: -20px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      width: 100%;
      padding-top: 38px;
      padding-left: 16px;
      padding-right: 16px;
      box-sizing: border-box;
      margin-bottom: 35px;
      background: #ffffff;
      border-radius: 8px;
      .headtitle {
        position: absolute;
        top: -20px;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 161px;
        height: 37px;
        text-align: center;
        line-height: 37px;
        font-size: 20px;
        font-weight: 600;
        color: #9e4900;
        background-image: url('./../../images/2023/标题背景.png');
        background-size: 100% 100%;
      }
      .list {
        width: 152px;
        height: 114px;
        margin-bottom: 16px;
        background: #f2f2f2;
        border-radius: 8px;
      }
    }
  }
</style>
